import _ from './LodashHelper'
import React from 'react'
import { useMediaQuery } from 'react-responsive'
import moment from 'moment'

function toFixed (num, fixed) {
  fixed = fixed || 0
  fixed = Math.pow(10, fixed)
  return Math.floor(num * fixed) / fixed
}

export function getArrayChanges (current, initial) {
  const deletes = _.difference(current, initial)
  const adds = _.difference(initial, current)
  const updates = _.intersection(initial, current)

  return {
    deletes,
    adds,
    updates,
    hasChanged: (deletes.length + adds.length) > 0
  }
}

export function ParseStartTime (date) {
  if (date.minute() > 0) {
    let minutes = ((date.minute() / 60))
    if (minutes <= 0.25) {
      return date.hour() + 0.25
    } else if (minutes <= 0.50) {
      return date.hour() + 0.50
    } else if (minutes <= 0.75) {
      return date.hour() + 0.75
    } else {
      return toFixed(date.hour() + 1)
    }
  } else {
    return toFixed(date.hour(), 2)
  }
}

export function FixTime (value) {
  const timeSplit = _.split(value, ':')
  const intMin = Math.ceil(parseInt(timeSplit[1]) / 60 * 100)
  let floatTime = parseFloat(`${timeSplit[0]}.${intMin}`)

  if (_.endsWith(timeSplit[1], 'PM')) {
    floatTime = floatTime + 12
  }

  return floatTime
}

export function BuildStartTimes (timeAsText = false) {
  var hour = 0
  var step = 0.25

  const times = []
  while (hour < 24) {
    var currentHour = Math.floor(hour)
    var currentMinutes = hour - currentHour
    if (hour < 1) {
      times.push({ Text: `12:${currentMinutes === 0 ? '00' : 60 * currentMinutes} AM`, Value: timeAsText ? `00:${currentMinutes === 0 ? '00' : 60 * currentMinutes}` : hour })
    } else if (hour < 12) {
      times.push({ Text: `${currentHour}:${currentMinutes === 0 ? '00' : 60 * currentMinutes} AM`, Value: timeAsText ? `${String(currentHour).padStart(2, 0)}:${currentMinutes === 0 ? '00' : 60 * currentMinutes}` : hour })
    } else if (currentHour === 12) {
      times.push({ Text: `${currentHour}:${currentMinutes === 0 ? '00' : 60 * currentMinutes} PM`, Value: timeAsText ? `${String(currentHour).padStart(2, 0)}:${currentMinutes === 0 ? '00' : 60 * currentMinutes}` : hour })
    } else {
      times.push({ Text: `${currentHour - 12}:${currentMinutes === 0 ? '00' : 60 * currentMinutes} PM`, Value: timeAsText ? `${String(currentHour).padStart(2, 0)}:${currentMinutes === 0 ? '00' : 60 * currentMinutes}` : hour })
    }
    hour = hour + step
  }

  return times
}

export function BuildDurationTimes () {
  var hour = 0.25
  var step = 0.25

  const times = []
  while (hour < 10.25) {
    var currentHour = Math.floor(hour)
    var currentMinutes = hour - currentHour
    times.push({ Text: `${currentHour}:${currentMinutes === 0 ? '00' : 60 * currentMinutes}`, Value: hour })
    hour = hour + step
  }
  return times
}

export const Greet = () => {
  const hour = moment().hour()

  let greeting = 'Good Day'

  if (hour < 12) {
    greeting = 'Good Morning'
  } else if (hour >= 12 && hour <= 17) {
    greeting = 'Good Afternoon'
  } else if (hour >= 17 && hour <= 24) {
    greeting = 'Good Evening'
  }

  return greeting
}

export const componentGetCompareProps = (path, current, previous, defaultValue, transfrom) => {
  let cur = _.get(current, path, defaultValue)
  let pre = _.get(previous, path, defaultValue)

  if (_.isFunction(transfrom)) {
    cur = transfrom(_, cur)
    pre = transfrom(_, pre)
  }

  return {
    Current: cur,
    Previous: pre,
    HasChanged: cur !== pre
  }
}

export const withMediaQuery = (queries = []) => Component => props => {
  const mediaProps = {}
  queries.forEach(q => {
    mediaProps[q[0]] = useMediaQuery(q[1])
  })
  return <Component {...mediaProps} {...props} />
}

export const convertMessageErrorsToFormErrors = (messages) => {
  let ret = {
    fields: [],
    data: {},
    success: false
  }

  if (_.isArray(messages) === false) {
    ret.data._error = 'Submit Failed: Errors are not an array!'
    return ret
  }

  let validationErrors = _.filter(messages, (m) => { return !!m.Field })

  if (validationErrors.length > 0) {
    ret.fields = _.map(validationErrors, (ve) => ve.Field)

    _.each(validationErrors, (ve) => {
      if (ve.Field) {
        if (_.has(ret.data, ve.Field)) {
          _.set(ret.data, ve.Field, _.join([_.get(ret.data, ve.Field), ve.Message], ','))
        } else {
          _.set(ret.data, ve.Field, ve.Message)
        }
      }
    })
    ret.success = true
    return ret
  } else {
    return null
  }
}
